import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context';
import WowSmartWidget from './WowSmartWidget';
import { bindWowSmartHash, getWowSmart, parseDp } from './sdk';
import { GF_SECTIONS } from './deepLinks';
import { isWowSmartAllowed } from './allowlist';
import { WS } from './assets';
import './wowsmart.css';

export default function WowSmartHost({ onRegister, hidden = false }) {
  const { token, user } = useAuth();
  const allowed = isWowSmartAllowed(user);
  const [open, setOpen] = useState(false);
  const [dp, setDp] = useState({ action: 'gf', params: {} });

  const applyParsed = useCallback((parsed) => {
    if (!isWowSmartAllowed(user)) return;
    const action = parsed?.action || 'gf';
    if (action === 'go') {
      const url = parsed.params?.url;
      if (url) {
        if (String(url).startsWith('http') || String(url).startsWith('/')) window.location.href = url;
        else window.location.href = `/${url}`;
      }
      return;
    }
    if ((action === 'gf_missions' || action === 'gf') && parsed.params?.opt_in && parsed.params?.id) {
      const id = Number(parsed.params.id);
      if (id) {
        const inst = window._wowsmart;
        const optIn = inst && inst.api && inst.api.requestMissionOptIn;
        if (typeof optIn === 'function') void optIn(id).catch(() => {});
      }
    }
    setDp({ action, params: parsed.params || {} });
    setOpen(true);
  }, [user]);

  const sdk = useMemo(() => getWowSmart({ openFromDeepLink: applyParsed }), [applyParsed]);

  useEffect(() => {
    if (!allowed) {
      window._wowsmart = { dp() { return false; }, api: {}, vapi() { return {}; } };
      return undefined;
    }
    window._wowsmart = sdk;
    window.__wowsmartDPCustom = (parsed) => {
      if (parsed.action === 'deposit' || parsed.action === 'cashier') {
        window.dispatchEvent(new CustomEvent('vb:open-deposit', { detail: parsed.params || {} }));
        return true;
      }
      return false;
    };
    return bindWowSmartHash(applyParsed);
  }, [sdk, applyParsed, allowed]);

  const guest = !(token || user);
  const section = GF_SECTIONS[dp.action] || 'home';
  const standalone = dp.params?.standalone === 'true' || dp.params?.standalone === true
    || dp.params?.standalone === '1' || dp.params?.standalone === 1;
  const hideMain = dp.params?.hide_main === 'true' || dp.params?.hide_main === true
    || dp.params?.hide_main === '1' || dp.params?.hide_main === 1;
  const missionCategory = dp.params?.category || 'overview';
  const boardType = dp.params?.type || 'weekly';
  const focusId = dp.params?.id || null;
  const wsApi = guest ? sdk.vapi('tr') : sdk.api;

  if (hidden || !allowed) return null;

  return (
    <>
      <button
        type="button"
        className="ws-launcher"
        onClick={() => sdk.dp('dp:gf')}
        aria-label="Hazine"
      >
        <img src={WS.nav.missions} alt="" />
      </button>
      <WowSmartWidget
        open={open}
        standalone={standalone}
        hideMain={hideMain}
        section={section}
        missionCategory={missionCategory}
        boardType={boardType}
        focusId={focusId}
        onClose={() => setOpen(false)}
        onDeepLink={(link) => applyParsed(parseDp(link))}
        wsApi={wsApi}
        guest={guest}
        onRegister={onRegister}
        openNickname={dp.action === 'gf_change_nickname'}
      />
    </>
  );
}
